import React from 'react'
import styled from 'styled-components'
import { DarkTheme } from '../components/Themes'




const Logo = styled.h1`
display: inline-block;
color: ${props => props.color === 'dark' ? DarkTheme.text : DarkTheme.body};
font-family: 'Pacifico',cursive;

position: fixed;
left: 1.3rem;
top: 2rem;
z-index:3;
font-size: 2rem; 

  /* ===== Mobile adjustment ===== */
  @media (max-width: 500px) {
    font-size: 1.5rem;
    left: 1rem;   /* subtle shift to the left */
  }
`

const LogoComponent = (props) => {
    return (
        <Logo color={props.theme}>
          RR
        </Logo>
    )
}

export default LogoComponent
